import store from '../store/store'
import axios from '../axios'

export default class RoleService {

  getUserPermissions(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserPermissions/' + id;
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updatePermission(permission) {
    if (permission.id) {
      return new Promise(async function(resolve, reject) {
        try {
          var path = '/v1/updateAssignedPermission/' + permission.id
          
          var response = await axios.put(path, permission)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      })
    } else {
      
    }
  }

  savePermission(permission) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/saveAssignedPermission/'
        
        var response = await axios.post(path, permission)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActivePermissions() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/activePermissions'
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  deleteRolePermissions(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/deleteAssignedPermission/' + id
        
        var response = await axios.delete(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // updatePermission(permission) {
  //   if (permission.id) {
  //     return new Promise(async function(resolve, reject) {
  //       try {
  //         var path = '/v1/updateAssignedPermission/' + permission.id
          
  //         var response = await axios.put(path, permission)
  //         // 
  //         resolve(response.data)
  //       } catch (err) {
          
  //         reject(err)
  //       }
  //     })
  //   } else {
      
  //   }
  // }

  // saveRole(role) {
  //   if (role.id) {
  //     return new Promise(async function(resolve, reject) {
  //       try {
  //         var path = '/v1/saveRole/'
          
  //         var response = await axios.put(path, role)
  //         // 
  //         resolve(response.data)
  //       } catch (err) {
          
  //         reject(err)
  //       }
  //     })
  //   } else {
      
  //   }
  // }
  
  getRolePermissions(roleId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/rolePermissions/' + roleId
        
        var response = await axios.get(path)
        if(store.getters['auth/getMyProfile'].role && store.getters['auth/getMyProfile'].role.id && store.getters['auth/getMyProfile'].role.id === roleId)
        store.dispatch(`auth/setUserPermissions`, response.data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllRolesByHard() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/roles'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/roles`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllRoles() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/roles`]) {
        resolve(store.getters[`commons/roles`])
  
      } else {
        try {
          var path = '/v1/roles'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/roles`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getRoleById(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/role/' + id
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateRole(role) {
    if (role.id) {
      return new Promise(async function(resolve, reject) {
        try {
          var path = '/v1/updateRole/' + role.id
          
          var response = await axios.put(path, role)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      })
    } else {
      
    }
  }

  saveRole(role) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/saveRole/'
        
        var response = await axios.post(path, role)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}